import React, { useState, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Grid, Card, CircularProgress, CardContent, CardHeader } from "@mui/material";

import httpClient from "../../../lib/httpClient";
import { saveUserMonitorData } from "../../util/userUtils";
import { MineAssetDescription } from "./MineAssetDescription";
import { MineAssetMap } from "./MineAssetMap";
import { HazardProvider } from "../../riskAssessment/HazardMapContext";
import { HazardsAssessmentWithTabs } from "../../riskAssessment/HazardsAssessment";
import { PolicyDetails } from "../../riskAssessment/hazardIdEnum";
import { getHazardsByUserAndPage } from "../../riskAssessment/hazardUtils";
export const MineAssetDetails = (props: RouteComponentProps<RouteComponentArgs>) => {
  const mineAssetId = props.match.params.id;

  const [isMineDataFetching, setIsMineDataFetching] = useState<boolean>(false);
  const [mineAssetDetails, setMineAssetDetails] = useState<MiningAsset | null>(null);
  const [hazardsList, setHazardsList] = useState([] as Hazard[]);

  useEffect(() => {
    const currentHazards = getHazardsByUserAndPage(PolicyDetails);
    setHazardsList(currentHazards);
  }, []);

  useEffect(() => {
    const getMineDetails = async () => {
      setIsMineDataFetching(true);
      saveUserMonitorData("mineAssetDetails", mineAssetId);

      const mineAssetDetailsResult = await httpClient().get(`/miningAssets/mine/${mineAssetId}`);
      setMineAssetDetails(mineAssetDetailsResult.data);
    };

    getMineDetails();
    setIsMineDataFetching(false);
  }, [mineAssetId]);

  return (
    <HazardProvider>
      <Grid container spacing={1} style={{ marginTop: 15 }}>
        <Grid item xs={8} sm={10} md={5}>
          <Card sx={{ height: "100%" }}>
            <CardHeader title={"Mine Asset Description"} />

            {isMineDataFetching ? (
              <Grid container justifyContent="center">
                <CircularProgress />
              </Grid>
            ) : (
              <CardContent style={{ paddingTop: "0" }}>
                <MineAssetDescription mineAsset={mineAssetDetails} />
              </CardContent>
            )}
          </Card>
        </Grid>

        <Grid item xs={12} sm={12} md={7}>
          <MineAssetMap mineAsset={mineAssetDetails}></MineAssetMap>
        </Grid>

        <Grid item xs={12} sm={12}>
          {mineAssetDetails?.latitude && mineAssetDetails?.longitude ? (
            <HazardsAssessmentWithTabs
              hazardsList={hazardsList}
              latitude={mineAssetDetails?.latitude}
              longitude={mineAssetDetails?.longitude}
            ></HazardsAssessmentWithTabs>
          ) : (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          )}
        </Grid>
      </Grid>
    </HazardProvider>
  );
};
